import { MapService } from './map.service';
import { NgZone } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { SearchService } from '../search.service';
import { StateService } from '../state/state.service';
import { MapboxService } from './mapbox/mapbox.service';
import { AuthService } from '../../auth/auth.service';
import { FlagService } from '../flag/flag.service';
import { EncryptedDataService } from '~app/auth/encrypted-data.service';
import { TranslateService } from '@ngx-translate/core';
import { InfoActionService } from '~app/element-utils/element-actions/info-action/info-action.service';
import { AlarmService } from '~app/alarm/alarm.service';
import { LinkingCrudService } from '~app/linking/linking.service';
import { MappingService } from '~app/linking/mapping.service';

export function mapServiceFactory() {
  return (
    http: HttpClient,
    ngZone: NgZone,
    searchService: SearchService,
    stateService: StateService,
    flagService: FlagService,
    authService: AuthService,
    encryptedData: EncryptedDataService,
    translateService: TranslateService,
    infoActionService: InfoActionService,
    alarmService: AlarmService,
    linkingService: LinkingCrudService,
    mappingService: MappingService,
  ): MapService => {
    return new MapboxService(
      stateService,
      http,
      searchService,
      flagService,
      ngZone,
      encryptedData,
      authService,
      translateService,
      infoActionService,
      alarmService,
      linkingService,
      mappingService,
    );
  };
}

export const mapServiceProvider = {
  provide: MapService,
  useFactory: mapServiceFactory(),
  deps: [
    HttpClient,
    NgZone,
    SearchService,
    StateService,
    FlagService,
    AuthService,
    EncryptedDataService,
    TranslateService,
    InfoActionService,
    AlarmService,
    LinkingCrudService,
    MappingService,
  ]
};
